import {
  PayloadAction,
  createSlice
} from '@reduxjs/toolkit';

export type ActivePane = 'map';

const initialState: ActivePane = 'map';

export const slice = createSlice({
  name: 'activePane',
  initialState: initialState as ActivePane,
  reducers: {
    setActivePane: (state: ActivePane, action: PayloadAction<ActivePane>) => {
      return action.payload;
    }
  }
});

export const {
  setActivePane
} = slice.actions;

export default slice.reducer;
